import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiError, client } from '../client'
import { queryKeys } from '../keys'
import type { NotificationPreferencesResponse } from '../queries/notifications'

export function useUpdateNotificationPreferences() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (preferences: Record<string, boolean>) => {
      const response = await client.PUT(
        '/api/v1/notifications/preferences' as never,
        {
          body: { preferences },
        } as never,
      )
      const { data, error } = response as {
        data?: NotificationPreferencesResponse
        error?: { detail?: string }
      }
      if (error) {
        throw new ApiError(
          500,
          (error as { detail?: string }).detail ??
            'Failed to update notification preferences',
        )
      }
      return data as NotificationPreferencesResponse
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.notifications.preferences(),
      })
    },
  })
}
